import {
  DREAM_TOUR_PROMOTION_CREATIVE,
  DREAM_TOUR_PROMOTION_NAME,
  DREAM_TOUR_PROMOTION_POSITION,
} from '../config/dreamTour';

type AnalyticsWindow = Window & {
  dataLayer?: Record<string, unknown>[];
};

function getPromotions(lotteryId: number | string): Record<string, unknown>[] {
  return [
    {
      id: lotteryId,
      name: DREAM_TOUR_PROMOTION_NAME,
      creative: DREAM_TOUR_PROMOTION_CREATIVE,
      position: DREAM_TOUR_PROMOTION_POSITION,
    },
  ];
}

function pushToDataLayer(event: Record<string, unknown>): void {
  const analyticsWindow = window as AnalyticsWindow;
  analyticsWindow.dataLayer ??= [];
  analyticsWindow.dataLayer.push(event);
}

export function trackDreamTourImpression(lotteryId: number | string): void {
  pushToDataLayer({ ecommerce: { promoView: { promotions: getPromotions(lotteryId) } } });
}

export function trackDreamTourClick(lotteryId: number | string): void {
  pushToDataLayer({ event: 'promotionClick', ecommerce: { promoClick: { promotions: getPromotions(lotteryId) } } });
}
